export var TemplateVisibility;
(function (TemplateVisibility) {
    TemplateVisibility["PUBLIC"] = "public";
    TemplateVisibility["PRIVATE"] = "private";
})(TemplateVisibility || (TemplateVisibility = {}));
export var TemplateAudience;
(function (TemplateAudience) {
    TemplateAudience["TUTOR"] = "tutor";
    TemplateAudience["PARENT"] = "parent";
    TemplateAudience["STUDENT"] = "student";
})(TemplateAudience || (TemplateAudience = {}));
//# sourceMappingURL=template.js.map